import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';

import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GetAgencyBO } from '../agency/agency.model';

@Injectable()

export class AgencyreportdataService extends Subject<DataStateChangeEventArgs> {
  constructor(private http: HttpClient, public errorService: ErrorService,) { super(); }
  
  public execute(state: GetAgencyBO): void {
    this.getoverallList(state).subscribe(x => super.next(x));
  }

  getoverallList(state?: GetAgencyBO): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Agency/Getoveralldata?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['overalldata'],
            count: response['total']
          })).pipe(map((e: any) => {
            return e;
          })
          )
  }
}
